import { useCallback, useMemo } from 'react';

import useAppRoutes from '~/hooks/useAppRoutes';
import analytics from '~/services/analytics';
import { ACTIONS } from '~/services/toasts/internalServerError';

import { testsApi } from '../../tests.api';
import { showTestError } from '../../tests.utils';

export const useDuplicateTest = () => {
  const appRoute = useAppRoutes('testsListEdit');
  const [duplicateTest, duplicateTestRequest] = testsApi.useDuplicateTestMutation();

  const handleDuplicateTest = useCallback(
    async ({
      id,
      shouldNavigate,
      data,
    }: Parameters<typeof duplicateTest>[0] & { shouldNavigate?: boolean }) => {
      analytics.trackEvent('test_duplicated');

      const result = duplicateTest({ id, data }).unwrap();
      result
        .then((duplicatedTest) => {
          if (shouldNavigate) {
            analytics.trackEvent('test_opened');
            appRoute.push('test', { testId: duplicatedTest.id });
          }
        })
        .catch((error) => {
          showTestError(ACTIONS.UPDATE, error as Error);
        });

      return result;
    },
    [appRoute, duplicateTest],
  );

  return useMemo(
    () => [handleDuplicateTest, duplicateTestRequest] as const,
    [handleDuplicateTest, duplicateTestRequest],
  );
};
